import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private toastController: ToastController) {}

  async presentToast(
    message: string = 'Sistema indisponível. \n Estamos trabalhando para resolver, por favor, tente novamente mais tarde.',
    icon: string,
    customCss: string,
    duration: number = 3000,
  ) {
    const toast = await this.toastController.create({
      message,
      duration,
      position: 'top',
      cssClass: 'snackbar-toast ' + customCss,
      icon: icon,
      animated: true,
    });
    toast.present();
  }

  showSuccess(message: string, customCss?: string, duration?: number) {
    this.presentToast(
      message,
      'checkmark-circle-outline',
      'toast-success' + (customCss ? ' ' + customCss : ''),
      duration,
    );
  }

  showError(message?: string, duration?: number) {
    this.presentToast(message, 'close-circle-outline', 'toast-error', duration);
  }

  showWarning(message: string, customCss?: string, duration?: number) {
    this.presentToast(
      message,
      'warning-outline',
      'toast-warning' + (customCss ? ' ' + customCss : ''),
      duration,
    );
  }
}
